
export async function testEmailConfiguration(): Promise<void> {
  console.log('🧪 Testing email configuration...');
  
  // Test environment variables
  console.log('Environment check:', {
    isDev: import.meta.env.DEV,
    mode: import.meta.env.MODE,
    prod: import.meta.env.PROD,
    forceEmail: import.meta.env.VITE_FORCE_EMAIL_IN_DEV
  });
  
  // Test Supabase connection
  try {
    const { supabase } = await import('./supabase');
    const { data: { session } } = await supabase.auth.getSession();
    console.log('✅ Supabase connection test:', {
      hasSession: !!session,
      hasAccessToken: !!session?.access_token
    });
  } catch (error) {
    console.error('❌ Supabase connection test failed:', error);
  }
  
  // Test edge function availability
  try {
    const { supabase } = await import('./supabase');
    const { data, error } = await supabase.functions.invoke('send-email', {
      body: {
        test: true
      }
    });
    console.log('Edge function test result:', { data, error });
  } catch (error) {
    console.error('❌ Edge function test failed:', error);
  }
}

// You can call this function in the browser console to test email setup
(window as any).testEmail = testEmailConfiguration;
export async function testEmailConnection(): Promise<{ success: boolean; details: any; error?: string }> {
  try {
    const { supabase } = await import('./supabase');
    
    console.log('Testing email connection...');
    
    // Check auth session
    const { data: { session }, error: sessionError } = await supabase.auth.getSession();
    
    if (sessionError) {
      return {
        success: false,
        error: 'Session error: ' + sessionError.message,
        details: { sessionError }
      };
    }
    
    // Test the send-email function with a simple request
    const { data, error } = await supabase.functions.invoke('send-email', {
      body: {
        to: 'test@example.com',
        subject: 'Test Email Connection',
        text: 'This is a test email to check the connection.',
        test: true // Add a flag to indicate this is a test
      },
      headers: {
        Authorization: `Bearer ${session?.access_token || 'anonymous'}`
      }
    });
    
    return {
      success: !error,
      details: {
        hasSession: !!session,
        hasAccessToken: !!session?.access_token,
        userEmail: session?.user?.email,
        functionResponse: data,
        functionError: error,
        environment: {
          isDev: import.meta.env.DEV,
          mode: import.meta.env.MODE,
          supabaseUrl: import.meta.env.VITE_SUPABASE_URL
        }
      },
      error: error?.message
    };
  } catch (err) {
    return {
      success: false,
      error: err instanceof Error ? err.message : String(err),
      details: { 
        catchError: err,
        environment: {
          isDev: import.meta.env.DEV,
          mode: import.meta.env.MODE
        }
      }
    };
  }
}

// Function to check the email provider (Resend) configuration in Supabase
export async function checkEmailConfiguration(): Promise<{ success: boolean; details: any; error?: string }> {
  try {
    const { supabase } = await import('./supabase');
    
    console.log('Checking email configuration...');
    
    const { data: { session } } = await supabase.auth.getSession();
    
    // Try to check if the email function exists
    const { data, error } = await supabase.functions.invoke('send-email', {
      body: {
        action: 'check-config' // Special action to check configuration
      },
      headers: {
        Authorization: `Bearer ${session?.access_token || 'anonymous'}`
      }
    });
    
    return {
      success: !error,
      details: {
        functionExists: !error || (error && !error.message.includes('Function not found')),
        configCheck: data,
        error: error
      }
    };
  } catch (err) {
    return {
      success: false,
      error: err instanceof Error ? err.message : String(err),
      details: { catchError: err }
    };
  }
}
